import React from "react";
import { Play } from "lucide-react";

const CineProHeader: React.FC = () => {
  return (
    <>
      {/* Titre CINEPRO */}
      <div className="w-full bg-white py-4 border-b">
        <div className="container mx-auto">
          <h1 className="text-2xl font-bold px-4">Cinépro</h1>
        </div>
      </div>

      {/* En-tête de la page (hors container) */}
      <div className="text-center mb-8 bg-[#e6f7ff] py-10 w-full">
        <h1 className="text-2xl font-bold text-orange-500 mb-2">
          Améliorez vos compétences professionnelles tout <br />
          en regardant des films captivants et didactiques
        </h1>
        <p className="text-xl text-gray-700 mb-6">
          soyez plus performant et plus productif en joignant l'utile à <br />
          l'agréable grâce à vos capsules cinémato-didactiques
        </p>
      </div>

      {/* Vidéo principale promotionnelle */}
      <div className="mb-12 max-w-3xl mx-auto">
        <div className="relative bg-gray-200 rounded-lg overflow-hidden aspect-video">
          <div
            className="absolute inset-0 flex items-center justify-center cursor-pointer"
            onClick={() =>
              alert("Vidéo promotionnelle - Non disponible actuellement")
            }
          >
            <div className="bg-white/30 rounded-full p-4">
              <Play size={48} className="text-orange-600" />
            </div>
          </div>
          <img
            src="/images/slide1.jpg"
            alt="Vidéo CinePro"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Indicateurs de pagination */}
        <div className="flex justify-center mt-4">
          {Array.from({ length: 12 }).map((_, index) => (
            <div
              key={index}
              className={`h-1.5 w-1.5 rounded-full mx-0.5 ${
                index === 0 ? "bg-orange-500" : "bg-gray-300"
              }`}
            ></div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CineProHeader; 